import RangeSlider from "@/components/frontend/ui/form/inputs/range-slider";
import { type FormRangeSliderBlock as FormRangeSliderBlockT } from "@/payload-types";

type FormRangeSliderBlockProps = FormRangeSliderBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormRangeSliderBlock: React.FC<FormRangeSliderBlockProps> = ({
	content,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	const defaultValue =
		content.mode === "range" ? [content.defaultMin ?? content.min ?? 0, content.defaultMax ?? content.max ?? 100] : (content.default ?? undefined);

	return (
		<RangeSlider
			name={fieldName}
			label={content.label}
			description={content.description}
			error={fieldError}
			required={content.required ?? false}
			value={(Array.isArray(fieldValue) || typeof fieldValue === "number" ? fieldValue : defaultValue) as number | number[]}
			onValueChange={(value) => onFieldChange?.(value)}
			onBlur={onFieldBlur}
			min={content.min ?? undefined}
			max={content.max ?? undefined}
			step={content.step ?? undefined}
			containerClassName={containerClassName}
		/>
	);
};
